/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierObjection.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-objection";

export class AutogenModelCarrierObjection<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierObjectionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierObjection extends ModelRow<RowCarrierObjectionFields> {
	constructor(values?: Partial<RowCarrierObjectionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierObjectionFields {
	company_id: string;
	descr: string;
	id: string;
	response_script: string;
	type_of: string;
}

